<template>
  <div>
    <DataTable
      :data="tarifapress"
      :columns="columnas"
      idField="idTarifaPres"
      :mostrarBotonTodos="true"
      :mostrarBotonNuevo="true"
      :mostrarEditar="true"
      :mostrarVer="true"
      :mostrarEliminar="false"
      mensajeVacio="No hay registros de tarifas para este prestador."
      @refresh="getDataPaginaTodos"
      @create="abrirModalCrear"
      @edit="(row) => abrirModalEditar(row.idTarifaPres)"
      @view="(row) => abrirEditar(row.idTarifaPres)"
      @delete="(row) => deleteTarifaPres(row.idTarifaPres)"
    >
      <!-- Botones extra: CSV y Excel -->
      <template #acciones-extra>
        <div class="col-auto">
          <button @click="exportarCSV" class="btn btn-success btn-sm d-flex align-items-center gap-1">
            <span class="material-icons" style="font-size:16px">download</span> CSV
          </button>
        </div>
        <div class="col-auto">
          <button @click="exportToExcel" class="btn btn-info btn-sm d-flex align-items-center gap-1">
            <span class="material-icons" style="font-size:16px">download</span> Excel
          </button>
        </div>
      </template>

      <!-- Celda valor alineada a la derecha -->
      <template #cell-valor="{ row }">
        <span class="d-block text-end">{{ row.valor }}</span>
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body">

              <!-- ID (solo edición) -->
              <div class="mb-3 row" v-if="btnEditar">
                <label class="col-2 col-form-label">ID</label>
                <div class="col-10">
                  <input type="text" class="form-control" v-model="datoTarifaPres.idTarifaPres" disabled />
                </div>
              </div>

              <!-- Tarifa -->
              <AutoComplete
                v-model="datoTarifaPres.idTarifa"
                endpoint="vwtarifas/search"
                idField="idTarifa"
                labelField="tarifarioDescripcion"
                label="Tarifa"
                placeholder="Buscar tarifa..."
                :initialLabel="datoTarifaPres.tarifarioDescripcion"
                :formatFn="formatTarifa"
              />

              <!-- Tarifa Conv (solo lectura) -->
              <div class="mb-3 row">
                <label class="col-2 col-form-label fw-bold">Tarifa Conv</label>
                <div class="col-10">
                  <input type="text" class="form-control" :value="datoTarifaPres.tarifaConvNombre" disabled />
                </div>
              </div>

              <!-- Elemento -->
              <AutoComplete
                v-model="datoTarifaPres.idElemento"
                endpoint="vwelementos/idclaselem-search/2"
                idField="idElemento"
                labelField="nombre"
                label="Elemento"
                placeholder="Buscar elemento..."
                :initialLabel="datoTarifaPres.elementoCodigo && datoTarifaPres.elementoNombre
                  ? datoTarifaPres.elementoCodigo + ' - ' + datoTarifaPres.elementoNombre
                  : datoTarifaPres.elementoNombre"
                :formatFn="formatElemento"
              />

              <!-- Valor -->
              <div class="mb-3 row">
                <label class="col-2 col-form-label fw-bold">Valor</label>
                <div class="col-10">
                  <input
                    type="number"
                    step="0.01"
                    class="form-control"
                    v-model.number="datoTarifaPres.valor"
                    required
                  />
                </div>
              </div>

            </div>
          </form>
          <div class="modal-footer">
            <button
              v-if="btnCrear"
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarTarifaPres"
              title="Guardar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              v-if="btnEditar"
              type="button"
              class="btn btn-warning"
              @click.prevent="guardarEditTarifaPres"
              title="Actualizar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { validarForm } from '../../modules/validacionesForms.js';
import dateFormat      from '../../modules/dateFormat.js';
import api             from "@/services/api";
import AutoComplete    from "@/components/AutoComplete.vue";
import DataTable       from "@/components/DataTable.vue";
import Swal            from 'sweetalert2';
import * as XLSX       from "xlsx";
import * as $          from 'jquery';
window["$"]      = $;
window["jQuery"] = $;

export default {
  components: { AutoComplete, DataTable },

  props: {
    p_idEmpresa:   { type: Number, required: true },
    p_idPrestador: { type: Number, required: true },
  },

  data() {
    return {
      tarifapress:    [],
      datoTarifaPres: {},
      titulo:         '',
      btnCrear:       false,
      btnEditar:      false,
      modalWindow:    true,

      columnas: [
        { field: 'tarifaConvNombre', label: 'Tarifario/Convenio' },
        { field: 'elementoCodigo',   label: 'Código'             },
        { field: 'elementoNombre',   label: 'Nombre'             },
        {
          field:  'valor',
          label:  'Valor',
          format: (v) => v ?? '',   // el slot #cell-valor maneja la alineación
        },
      ],
    };
  },

  mounted() {
    this.getDataPaginaTodos();
  },

  methods: {
    // ── Carga de datos ────────────────────────────────────
    getDataPaginaTodos() {
      api.get('/vwtarifapress/idprestador/' + this.p_idPrestador)
        .then(r  => { this.tarifapress = r.data; })
        .catch(e => console.error('Error al cargar tarifas:', e));
    },

    // ── Validación ────────────────────────────────────────
    validarFormulario() {
      const fields = ['idTarifa', 'idPrestador', 'idTarifaConv', 'idElemento', 'valor'];
      return validarForm(this.datoTarifaPres, fields, fields);
    },

    // ── CRUD ──────────────────────────────────────────────
    async guardarTarifaPres() {
      if (this.validarFormulario() !== 1) return;
      try {
        const payload = {
          ...this.datoTarifaPres,
          valor: Number(this.datoTarifaPres.valor),
        };
        await api.post('/tarifapress', payload);
        $('#ventanaModal').modal('hide');
        Swal.fire({ icon: 'success', title: '¡Correcto!', text: 'Tarifa creada exitosamente.' });
        this.getDataPaginaTodos();
      } catch {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Inténtelo de nuevo.' });
      }
    },

    async guardarEditTarifaPres() {
      if (this.validarFormulario() !== 1) return;
      try {
        const payload = {
          ...this.datoTarifaPres,
          valor: Number(this.datoTarifaPres.valor),
        };
        await api.post('/tarifapress', payload);
        $('#ventanaModal').modal('hide');
        Swal.fire({ icon: 'success', title: '¡Correcto!', text: 'Tarifa actualizada exitosamente.' });
        this.getDataPaginaTodos();
      } catch (error) {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Inténtelo de nuevo.' });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deleteTarifaPres(idTarifaPres) {
      const confirm = await Swal.fire({
        title: '¿Eliminar registro?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete('/tarifapress/' + idTarifaPres);
        this.getDataPaginaTodos();
      } catch {
        Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo eliminar.' });
      }
    },

    // ── Modales ───────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow    = true;
      this.datoTarifaPres = { idPrestador: this.p_idPrestador };
      this.titulo         = 'Nueva Tarifa Prestador';
      this.btnCrear       = true;
      this.btnEditar      = false;
      api.get(`/vwtarifaconvs/idprestador/${this.p_idPrestador}/max`)
        .then(r => {
          this.datoTarifaPres.idTarifaConv     = r.data.idTarifaConv;
          this.datoTarifaPres.tarifaConvNombre = r.data.nombre;
        });
      this.$nextTick(() => $('#ventanaModal').modal('show'));
    },

    async abrirModalEditar(idTarifaPres) {
      this.modalWindow = true;
      this.titulo      = 'Editar Tarifa Prestador';
      this.btnCrear    = false;
      this.btnEditar   = true;
      if (idTarifaPres != null) {
        try {
          const resp = await api.get('/vwtarifapress/' + idTarifaPres);
          this.datoTarifaPres = resp.data;
        } catch (e) {
          console.error('Error al cargar tarifa:', e);
          return;
        }
      }
      this.$nextTick(() => $('#ventanaModal').modal('show'));
    },

    abrirEditar(idTarifaPres) {
      if (idTarifaPres != null) this.$router.push('/tarifapresmd/' + idTarifaPres);
    },

    // ── Exportaciones ─────────────────────────────────────
    exportarCSV() {
      if (!this.tarifapress.length) {
        Swal.fire({ icon: 'warning', title: 'Advertencia', text: 'No hay datos para exportar.' });
        return;
      }
      const headers = ['Tarifario/Convenio', 'Código', 'Nombre Elemento', 'Valor'];
      const rows    = this.tarifapress.map(t =>
        [t.tarifaConvNombre, t.elementoCodigo, t.elementoNombre, t.valor]
          .map(v => `"${(v ?? '').toString().replace(/"/g, '""')}"`)
          .join(';')
      );
      const content = '\uFEFF' + [headers.join(';'), ...rows].join('\n');
      const link    = document.createElement('a');
      link.href     = URL.createObjectURL(new Blob([content], { type: 'text/csv;charset=utf-8;' }));
      link.download = `tarifas_prestador_${this.p_idPrestador}.csv`;
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    exportToExcel() {
      if (!this.tarifapress.length) {
        Swal.fire({ icon: 'warning', title: 'Advertencia', text: 'No hay datos para exportar.' });
        return;
      }
      const headers = ['Tarifario/Convenio', 'Código', 'Nombre Elemento', 'Valor'];
      const data    = this.tarifapress.map(t => [
        t.tarifaConvNombre, t.elementoCodigo, t.elementoNombre, t.valor,
      ]);
      const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'TarifasPrestador');
      XLSX.writeFile(wb, `tarifas_prestador_${this.p_idPrestador}.xlsx`);
    },

    // ── Formato ───────────────────────────────────────────
    formatTarifa(item) {
      return `${item.elementoCodigo} - ${item.elementoNombre} (${item.tarifarioDescripcion})`;
    },
    formatElemento(item) {
      return `${item.elementoCodigo} - ${item.elementoNombre}`;
    },
    getFormattedDate(date) { return dateFormat.getFormattedDate(date); },
  },
};
</script>